import { useAuth } from 'context/authContext';
import { validateUserPermissions } from 'utils/validateUserPermissions';

type UseCanParams = {
  permissions?: string[];
  role?: string[];
};

export function useCan({ permissions, role }: UseCanParams): boolean {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return false;
  }

  const userHasValidPermissions = validateUserPermissions({
    user,
    permissions,
    roles: role,
  });

  return userHasValidPermissions;
}
